import React, { useContext, useEffect, useState } from 'react';
import { FundContext } from '../FundPage';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import FlexWrapper from '../../../FlexWrapper';
import Table from '../../../../components/Table/Table';
import PageContentToggle from '../../../../components/Menus/PageContentToggle';
import TextInput from '../../../../components/Input/TextInput';
import SearchField from '../../../../components/Input/SearchField';
import { Search } from 'react-feather';

const FundHoldings = ({portfolio}) => {
    const { setSelectedTab, holdings } = useContext(FundContext)
    const [data, setData] = useState([])
    const [dataView, setDataView] = useState("All")
    const [typeFilter, setTypeFilter] = useState(null)
    const [countryFilter, setCountryFilter] = useState(null)
    const [searchFilter, setSearchFilter] = useState("")
    const [dates, setDates] = useState([])
    const [selectedDate, setSelectedDate] = useState("")

    const all = data ? data : []
    const topTen = data && Array.isArray(data) ? data.slice(0, 9) : []

    // const countries = [...new Set(all.map(item => item.country))]
    const types = [...new Set(all.map(item => item.assetClass))]

    // const totalWeight = data && data.data && data.data.reduce((acc, item) => acc + item.currentWeight, 0)
    // const totalWeightTarget = data && data.data && data.data.reduce((acc, item) => acc + item.targetWeight, 0)

    useEffect(() => {
        setSelectedTab("Holdings")

        setDates(Object.keys(holdings));
        const firstDate = Object.keys(holdings)[0];
        setSelectedDate(firstDate);
        if (firstDate && holdings[firstDate]) {
            setData([...holdings[firstDate].sort((a, b) => b.currentWeight - a.currentWeight) ])
        }
    }, [])

    useEffect(() => {
        if (!holdings || !selectedDate) {
            return;
        }
        setData([...holdings[selectedDate].sort((a, b) => b.currentWeight - a.currentWeight) ])
    }, [selectedDate, holdings])

    const handleSort = (a, b) => {
        return 0
    }

    const handleFilter = (item) => {
        if (searchFilter && !item.assetName.toLowerCase().includes(searchFilter.toLowerCase())) return false
        if (typeFilter && item.assetClass !== typeFilter) return false
        if (countryFilter && item.country !== countryFilter) return false
        return true
    }

    const headers = [
        {
            text: <div className='sorting-header left' > Asset Name </div>
        },
        {
            text: <div className='sorting-header left' > Type </div>
        },
        {
            text: <div className='sorting-header left' > Country </div>
        },
        {
            text: <div className='sorting-header left' > Credit Rating </div>
        },
        {
            text: <div className='sorting-header right' style={{ textAlign: "right" }} > % of {portfolio ? "Portfolio" :"Fund"} </div>
        },
    ]

    const colWidths = ["35%", "20%", "20%", "10%", "15%"]
    const dataMap = (holdings) => {
        const rows = holdings.filter(handleFilter).sort(handleSort).map((item) => {
            return (
                <tr key={item.assetName}>
                    <td >{item.assetName || "-"}</td>
                    <td >{item.assetClass || "-"}</td>
                    <td >{item.country || "-"}</td>
                    <td >{item.creditRating || "-"}</td>
                    <td style={{ textAlign: "right" }}>{item.currentWeight ? item.currentWeight.toFixed(2) + "%" : "-"}</td>
                </tr>
            )
        })
        const finalRow = (
            <tr>
                <td style={{ textAlign: "right", fontWeight: 600 }} colSpan={4}>Total Value of Assets</td>

                <td style={{ textAlign: "right", fontWeight: 600 }}>{holdings.reduce((acc, item) => acc + item.currentWeight, 0) ? holdings.reduce((acc, item) => acc + item.currentWeight, 0).toFixed(3) + "%" : "-"}</td>
            </tr>
        )
        
        return data.length > 0 ? [...rows, finalRow] : []
    }

    return (
        <PageGridItem container col="1 / span 12" gap='l' direction='col' >
            <FlexWrapper fullWidth gap="m" align='center' style={{ overflowX: 'auto', scrollbarWidth: 'none' }}/*wrap='wrap'*/>
                <FlexWrapper gap="l" align='center' style={{ minWidth: 500 }}>
                    <div style={{ minWidth: "100px", transform: "translateY(4px)", paddingLeft: '8px' }}>
                        <PageContentToggle labels={[
                            { label: "All", active: dataView === "All", onClick: () => setDataView("All") },
                            { label: "Top 10", active: dataView === "Top 10", onClick: () => setDataView("Top 10") },
                        ]} />
                    </div>
                    <TextInput icon={<Search />} placeholder="Search" onChange={(e) => setSearchFilter(e.target.value)} size="small" />
                    <SearchField
                        placeholder="Type"
                        onChange={(e) => setTypeFilter(e.value)}
                        value={typeFilter && { label: typeFilter, value: typeFilter }}
                        options={types.map((s, index) => ({ label: s, value: s }))}
                        width="m"
                        onClear={() => setTypeFilter(null)}
                        isClearable
                        size="small"
                    />
                    <SearchField
                        placeholder="Date"
                        onChange={(e) => setSelectedDate(e.value)}
                        value={selectedDate && { label: selectedDate, value: selectedDate }}
                        options={dates.map((s, index) => ({ label: s, value: s }))}
                        width="m"
                        size="small"
                    />
                </FlexWrapper>
                {/* <p style={{minWidth: 215}} className="investment-mix-date" >Last Updated: TODO {format(new Date(), "dd/MM/yyyy")}
                </p> */}
            </FlexWrapper>
            <Table
                headers={headers}
                colWidths={colWidths}
                dataMap={dataMap(dataView === "Top 10" ? topTen : all)}
                height="calc(100vh - 26.5rem)"
                wrapperStyle={{ overflowY: "auto" }}
            />
        </PageGridItem>
    );
}

export default FundHoldings;